// ============================================
// 应用入口
// ============================================

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import permission from './directive/permission'

Vue.config.productionTip = false

// 注册 Element UI
Vue.use(ElementUI, { size: 'small' })

// 注册权限指令
Vue.directive('permission', permission)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
